var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339.63,
    height: 235.185,
    viewBox: "0 0 339.63 235.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team",
    transform: "translate(-31.453 -85.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    "data-name": "Group 1538",
    transform: "translate(31.453 97.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M182.089,140.965c-12.18-39.289-67.067-51.946-98.523-22.583q-.678.633-1.354,1.286C37.116,163.257,58.42,270.675,152.534,297.9s192.005-22.491,197.5-66.934-37.921-58.408-105.3-45.98C206.667,192.007,189.671,165.423,182.089,140.965Z",
    transform: "translate(-37.637 -102.264)",
    fill: "#ffd4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M313.853,167.259c-12.592,1.823-16.082,11.743-6.359,18.78,3.214,2.326,7.8,4.259,14.34,5.223,24.905,3.674,38.122-6.124,28.138-18.827C343.811,164.593,326.331,165.452,313.853,167.259Z",
    transform: "translate(-91.111 -121.839)",
    fill: "#ffd4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M53.418,279.853c-7.828-8.958-19.294-6.933-21.587,4.027-.758,3.622-.469,8.13,1.708,13.7,8.3,21.2,24.3,26.828,32.061,12.952C70.393,301.964,61.177,288.729,53.418,279.853Z",
    transform: "translate(-31.453 -155.048)",
    fill: "#ffd4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M443.61,289.676c-1.16,5.4,3.854,9.224,9.536,7.143a11.705,11.705,0,0,0,5.457-4.344c6.419-8.88,3.168-16.5-5.77-15.716C447.317,277.243,444.76,284.325,443.61,289.676Z",
    transform: "translate(-122.332 -155.808)",
    fill: "#ffd4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M398.737,205.931c6.052,1.123,10.438-3.269,8.2-8.356a11.13,11.13,0,0,0-4.793-4.926c-9.875-5.858-18.5-3.1-17.769,4.862C384.82,202.424,392.739,204.818,398.737,205.931Z",
    transform: "translate(-109.293 -129.045)",
    fill: "#ffd4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M211.583,121.771c4.792,3.474,10.959,1.369,11.6-4.065a9.745,9.745,0,0,0-1.705-6.334c-5.735-9.243-14.817-10.319-18.292-2.954C201.042,112.962,206.834,118.329,211.583,121.771Z",
    transform: "translate(-69.234 -102.666)",
    fill: "#ffd4cf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(50.092 117.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1539",
    "data-name": "Group 1539",
    transform: "translate(64.426 161.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M138.227,387.239c.043,2.613.1,5.332.16,8.082h28.339c.054-3.01.1-5.9.126-8.6.086-7.335.1-13.37.089-17.122,0-2.661-.016-4.17-.016-4.17l-28.9-.272s0,2.22.023,5.85C138.068,375.041,138.119,380.818,138.227,387.239Z",
    transform: "translate(-138.027 -365.155)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M138.056,372.973c.019,4.036.069,9.813.177,16.235a159.628,159.628,0,0,0,28.626-.521c.086-7.334.1-13.37.089-17.122Z",
    transform: "translate(-138.033 -367.123)",
    fill: "#000b29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    "data-name": "Group 1540",
    transform: "translate(28.872 161.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M92.449,381.445c.032,4.107.087,8.813.178,13.876h28.342c.07-2.964.126-5.893.172-8.691.1-6.005.149-11.412.174-15.3.022-3.825.022-6.176.022-6.176l-28.91.272s-.023,2.726-.016,7.312C92.412,375.164,92.424,378.107,92.449,381.445Z",
    transform: "translate(-92.41 -365.155)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M92.412,375.475c0,2.425.012,5.368.037,8.706a196.615,196.615,0,0,0,28.693,5.185c.1-6.005.149-11.412.174-15.3Z",
    transform: "translate(-92.411 -367.891)",
    fill: "#000b29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549",
    transform: "translate(40.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M143.1,158.347s4.554-3.9,4.539-7.751-2.959-2.714-4.539-6.3-6.274-5.777-8.849-5.339-8.01-8.491-15.382-6.915-6.731,9.979-9.906,11.2-2.29,6.215-.616,7.353,2.381,5.71,3.323,5.607S143.1,158.347,143.1,158.347Z",
    transform: "translate(-106.77 -131.852)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(0 24.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M112.433,169.2s-2.863-3.395-4.992-.588.882,11.1,6.093,9.073Z",
    transform: "translate(-106.751 -167.496)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1541",
    "data-name": "Group 1541",
    transform: "translate(1.118 2.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M112.713,176.436a.437.437,0,0,1-.424-.286c-.807-2.559-3.79-3.6-3.82-3.607a.38.38,0,0,1-.255-.505.458.458,0,0,1,.567-.227c.14.046,3.426,1.181,4.356,4.129a.389.389,0,0,1-.3.483A.507.507,0,0,1,112.713,176.436Z",
    transform: "translate(-108.185 -171.785)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    "data-name": "Group 1542",
    transform: "translate(2.195 4.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M110.007,175.828a.481.481,0,0,1-.239-.062.367.367,0,0,1-.132-.541,3.927,3.927,0,0,1,1.653-1.185.464.464,0,0,1,.582.2.376.376,0,0,1-.222.517,3.13,3.13,0,0,0-1.273.894A.455.455,0,0,1,110.007,175.828Z",
    transform: "translate(-109.567 -174.004)",
    fill: "#ea5143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547",
    transform: "translate(34.088 24.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M151.587,169.2s2.863-3.395,4.992-.588-.882,11.1-6.093,9.073Z",
    transform: "translate(-150.486 -167.496)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544",
    transform: "translate(0.697 2.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M151.821,176.436a.437.437,0,0,0,.424-.286c.807-2.559,3.79-3.6,3.82-3.607a.38.38,0,0,0,.255-.505.458.458,0,0,0-.567-.227c-.14.046-3.426,1.181-4.357,4.129a.389.389,0,0,0,.306.483A.507.507,0,0,0,151.821,176.436Z",
    transform: "translate(-151.38 -171.785)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(2.245 4.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M155.269,175.828a.481.481,0,0,0,.238-.062.367.367,0,0,0,.132-.541,3.927,3.927,0,0,0-1.653-1.185.464.464,0,0,0-.582.2.376.376,0,0,0,.222.517,3.124,3.124,0,0,1,1.272.894A.457.457,0,0,0,155.269,175.828Z",
    transform: "translate(-153.366 -174.004)",
    fill: "#ea5143"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M138.175,192.339v8.245s-2.765,4.2-6.5,4.485-7.055-3.615-7.055-3.615v-8.535Z",
    transform: "translate(-110.691 -150.418)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M138.175,192.339V196c-2.51,2.476-6.966,3.094-13.56,2.229v-5.307Z",
    transform: "translate(-110.691 -150.418)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M145.135,157.2a71.671,71.671,0,0,1-1.2,10.414c-.171.8-.366,1.551-.581,2.225-1.952,6.075-6.832,16.494-20.5,12.154-6.035-1.916-8.832-7.892-10.079-13.971a52.4,52.4,0,0,1-.912-11.28,8.519,8.519,0,0,1,4.912-7.325c8.065-4.065,16.575-2.55,22.178-.634A8.614,8.614,0,0,1,145.135,157.2Z",
    transform: "translate(-107.876 -136.454)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M113.04,177.166s1.326,7.024,2.578,9.584,4.676,3.043,5.96,5.208c1.832,3.085,4.626,5.531,9.22,4.04,3.823-1.24,3.65-2.978,5.792-4.323,3.669-2.3,5.488-4.839,5.636-6.94a60.268,60.268,0,0,1,1.97-7.978l-1.97-.123a44.415,44.415,0,0,1-2.773,4.343c-1.657-3.235-9.639-.882-9.639-.882l-1.525.439-1.565-.439s-8.076-2.253-9.671,1.14a12.1,12.1,0,0,1-2.132-4.406Zm15.25,4.464c9.155-1.4,7.519,3.369,7.46,3.539v0l0,0a9.062,9.062,0,0,1-1.882,1.268c-3.547,1.7-3.931,1.447-5.33,1.5a11.556,11.556,0,0,1-5.38-1.3,15.247,15.247,0,0,1-2.563-1.733S119.153,180.535,128.29,181.63Z",
    transform: "translate(-108.138 -145.598)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M124.9,170.794c0,.88-.511,1.594-1.139,1.594s-1.139-.714-1.139-1.594.51-1.593,1.139-1.593S124.9,169.914,124.9,170.794Z",
    transform: "translate(-110.252 -143.316)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M142.28,170.794c0,.88-.511,1.594-1.14,1.594S140,171.674,140,170.794s.511-1.593,1.139-1.593S142.28,169.914,142.28,170.794Z",
    transform: "translate(-114.085 -143.316)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M144.859,163.566s-4.708-1.654-8.333-.262l.362,1.792s5.32-.4,8,.566A2.786,2.786,0,0,0,144.859,163.566Z",
    transform: "translate(-113.319 -141.335)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M118.433,163.575s4.743-1.667,8.394-.264l-.365,1.806s-5.36-.4-8.061.57A2.806,2.806,0,0,1,118.433,163.575Z",
    transform: "translate(-109.279 -141.336)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    transform: "translate(18.951 26.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M132.7,177.743a5.188,5.188,0,0,0,1.595-.3.378.378,0,0,0,.241-.511.461.461,0,0,0-.574-.215,2.948,2.948,0,0,1-1.767.148.419.419,0,0,1-.217-.365,52.907,52.907,0,0,1,.266-6,.407.407,0,0,0-.4-.422.426.426,0,0,0-.475.358,51.774,51.774,0,0,0-.264,6.144,1.189,1.189,0,0,0,.641.956A2.041,2.041,0,0,0,132.7,177.743Z",
    transform: "translate(-131.065 -170.081)",
    fill: "#f97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M125.962,184.973a5.02,5.02,0,0,0,5.189,4.248,4.836,4.836,0,0,0,5.168-4.248Z",
    transform: "translate(-110.988 -148.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M145.135,157.2a71.671,71.671,0,0,1-1.2,10.414l-1.969-.124s.477-2.7.7-4.467.595-5.057-1.1-5.468-.7-4.166-3.045-5.8-7.563-3.071-11.025-1.175-7.4.846-9,1.175-3.766,2.284-3.18,4.113-1.171,2.938-1.6,4.829.938,6.984.938,6.984l-1.881.337a52.4,52.4,0,0,1-.912-11.28,8.519,8.519,0,0,1,4.912-7.325c8.065-4.065,16.575-2.55,22.178-.634A8.614,8.614,0,0,1,145.135,157.2Z",
    transform: "translate(-107.876 -136.454)",
    fill: "#18315b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(22.873 50.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1550",
    "data-name": "Group 1550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M161.153,328.466a174.707,174.707,0,0,1-26.744,3.9c-.4.026-.805.053-1.21.077q-1.839.11-3.677.182a170.651,170.651,0,0,1-18.2-.274q-1.836-.126-3.669-.292c-.391-.033-.782-.07-1.175-.11a177.465,177.465,0,0,1-21.739-3.485c-.072-5.939.01-24.715.42-45.077.048-2.447.1-4.917.161-7.391.642-26.836,1.882-54.076,4.111-56.8,2.137-2.611,8.579-5.93,14.737-8.924l1.1-.532c1.384-.669,2.738-1.317,4.011-1.932,2.729-1.32,5.082-2.494,6.536-3.4v.746s3.316,3.9,7.052,3.614c3.406-.261,6-3.759,6.44-4.386,1.606,1.006,4.493,2.393,7.838,3.965.931.439,1.894.888,2.876,1.351q.541.254,1.09.514c6.811,3.212,14.153,6.833,16.358,9.525a3.159,3.159,0,0,1,.472.99c1.3,3.927,2.114,16.958,2.606,32.738l.006.171c.022.638.039,1.281.057,1.927,0,.084.005.17.008.255.161,5.536.283,11.363.377,17.218.008.464.018.929.023,1.394,0,.234.006.465.008.7q.033,1.73.048,3.453.02,1.27.034,2.54C161.352,302.28,161.252,322.244,161.153,328.466Z",
    transform: "translate(-84.714 -204.378)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551",
    transform: "translate(65.681 36.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M179.2,271.906c-2.145-3.115-4.447-6.294-6.616-9.105-.005-.008-.012-.015-.016-.021-.911-1.18-1.8-2.295-2.64-3.314a.4.4,0,0,0-.044-.052c-.263-.32-.525-.631-.779-.933a.558.558,0,0,1-.093-.164l0,0a.491.491,0,0,1,.21-.568.64.64,0,0,1,.829.1c2.6,3.07,5.937,7.482,9.087,11.96l.006.171C179.163,270.617,179.18,271.261,179.2,271.906Z",
    transform: "translate(-168.984 -257.64)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M177.58,225.907s13.441,21.9,21.634,32.994c0,0,4.659-3.806,10.719-8.9,6.57-5.521,15.556-14.747,15.556-14.747l4.973,5.244s-20.19,32.307-29.246,36.366-25.743-24.677-25.743-24.677Z",
    transform: "translate(-104.734 -210.986)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    transform: "translate(5.322 76.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M102.156,339.34h-.022a.571.571,0,0,1-.586-.559c.7-17.683-9.607-23.412-9.711-23.468a.508.508,0,0,1-.208-.741.652.652,0,0,1,.832-.187,17.591,17.591,0,0,1,5.481,5.307c2.41,3.444,5.2,9.559,4.821,19.128A.581.581,0,0,1,102.156,339.34Z",
    transform: "translate(-91.542 -314.308)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553",
    transform: "translate(59.275 54.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M161.418,313.111a.585.585,0,0,1-.606-.5c-.326-3.724,1.054-6.44,2.8-9.879.511-1.006,1.04-2.046,1.581-3.213,3.389-7.31,1.686-15.667,1.668-15.751a.548.548,0,0,1,.486-.631.606.606,0,0,1,.709.432c.075.354,1.786,8.759-1.739,16.362-.549,1.183-1.081,2.232-1.6,3.246-1.74,3.426-3,5.9-2.7,9.35a.565.565,0,0,1-.559.581Z",
    transform: "translate(-160.765 -283.129)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(24.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M116.231,207.805c.26,1.741.641,4,1.057,6.565.127.762.254,1.552.384,2.363.422,2.65.859,5.533,1.231,8.448.1.782.195,1.568.283,2.35.328,2.886.576,5.754.665,8.418q.044,1.21.035,2.358a33.4,33.4,0,0,1-.41,5.5q-.267,1.516-.472,2.964-.173,1.2-.31,2.363c-.355,3.007-.532,5.806-.582,8.446q-.022,1.2-.009,2.355c.027,3,.218,5.788.5,8.446.083.8.175,1.578.269,2.35.363,2.9.807,5.669,1.223,8.4q.181,1.175.354,2.342c.181,1.25.352,2.5.5,3.758.157,1.334.256,2.894.3,4.624.023.757.035,1.547.038,2.363.012,2.587-.062,5.452-.2,8.448q-.053,1.174-.118,2.376c-.15,2.783-.348,5.646-.57,8.471q-.1,1.193-.2,2.374c-.246,2.941-.517,5.806-.792,8.471-.083.809-.165,1.6-.248,2.366-.316,2.933-.623,5.541-.892,7.62a170.292,170.292,0,0,0,18.2.273c.142-2.214.528-5.785.91-9.989.071-.769.139-1.562.207-2.371.228-2.673.434-5.531.57-8.414.039-.79.071-1.584.1-2.374.091-2.878.094-5.738-.044-8.419-.041-.814-.094-1.609-.165-2.384-.071-.793-.157-1.565-.26-2.311a41.985,41.985,0,0,1-.39-6.129c0-.793.026-1.58.068-2.371.139-2.742.475-5.488.865-8.405.1-.775.213-1.563.322-2.366.352-2.595.718-5.346,1.007-8.359.077-.772.145-1.562.21-2.371.2-2.584.337-5.359.358-8.385q.008-1.17-.009-2.39c-.032-2.618-.156-5.42-.4-8.437-.021-.268-.041-.539-.065-.812-.044-.527-.083-1.06-.109-1.593a71.279,71.279,0,0,1,.059-8.406q.071-1.189.175-2.379c.245-2.826.6-5.625,1.016-8.308q.181-1.2.378-2.366c.5-2.941,1.03-5.709,1.521-8.182.163-.814.319-1.6.467-2.343.334-1.67.623-3.159.836-4.42-3.346-1.573-6.231-2.959-7.838-3.965-.44.627-3.033,4.125-6.44,4.386-3.736.288-7.052-3.614-7.052-3.614V204.4C121.313,205.31,118.96,206.484,116.231,207.805Z",
    transform: "translate(-116.231 -204.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565",
    transform: "translate(1.057 7.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M117.587,217.862c.127.762.254,1.552.384,2.363A55.225,55.225,0,0,0,130,218.873a35.948,35.948,0,0,1,13.091-.276c.163-.814.319-1.6.467-2.343a38.93,38.93,0,0,0-14.155.318A51.67,51.67,0,0,1,117.587,217.862Z",
    transform: "translate(-117.587 -215.755)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555",
    transform: "translate(1.616 10.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M119.66,233.454c.1.782.195,1.568.283,2.35a59.836,59.836,0,0,0,10.517-1.349,35.889,35.889,0,0,1,11.192-.528q.181-1.2.378-2.366a39.141,39.141,0,0,0-12.167.591A57.163,57.163,0,0,1,119.66,233.454Z",
    transform: "translate(-119.66 -231.333)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556",
    transform: "translate(2.563 21.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M120.876,249.007q.044,1.21.035,2.358a62.241,62.241,0,0,0,9.817-1.326,36.069,36.069,0,0,1,10-.641q.071-1.189.175-2.379a39.274,39.274,0,0,0-10.774.717A60.489,60.489,0,0,1,120.876,249.007Z",
    transform: "translate(-120.876 -246.917)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557",
    transform: "translate(1.406 32.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M119.391,266.981a58.583,58.583,0,0,0,11.009-1.358,36,36,0,0,1,10.118-.63c-.021-.268-.041-.539-.065-.812-.044-.527-.083-1.06-.109-1.593a39.228,39.228,0,0,0-10.54.733,57.32,57.32,0,0,1-10.1,1.3Q119.528,265.819,119.391,266.981Z",
    transform: "translate(-119.391 -262.502)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558",
    transform: "translate(0.81 43.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M118.632,282.564a56.5,56.5,0,0,0,11.6-1.358,36.082,36.082,0,0,1,10.522-.6q.008-1.169-.009-2.39a39.277,39.277,0,0,0-11.11.69,54.327,54.327,0,0,1-10.994,1.306Q118.618,281.41,118.632,282.564Z",
    transform: "translate(-118.626 -278.086)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559",
    transform: "translate(1.311 53.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M119.269,295.793c.083.8.175,1.578.269,2.35a59.03,59.03,0,0,0,10.835-1.353,36.013,36.013,0,0,1,9.955-.649c.077-.772.145-1.562.21-2.371a39.2,39.2,0,0,0-10.761.717A56.137,56.137,0,0,1,119.269,295.793Z",
    transform: "translate(-119.269 -293.669)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    transform: "translate(2.803 64.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M121.183,311.329q.181,1.175.354,2.342a64.132,64.132,0,0,0,9.259-1.3,36.207,36.207,0,0,1,8.626-.724c.1-.775.213-1.563.322-2.366a39.433,39.433,0,0,0-9.545.787A61.653,61.653,0,0,1,121.183,311.329Z",
    transform: "translate(-121.183 -309.252)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561",
    transform: "translate(3.96 75.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M122.668,326.837c.023.757.035,1.547.038,2.363a66.573,66.573,0,0,0,8.417-1.245,36.553,36.553,0,0,1,7.693-.746c0-.793.026-1.58.068-2.371a39.66,39.66,0,0,0-8.358.816A65.989,65.989,0,0,1,122.668,326.837Z",
    transform: "translate(-122.668 -324.838)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562",
    transform: "translate(3.683 86.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M122.312,344.809a66.559,66.559,0,0,0,8.733-1.269,36.168,36.168,0,0,1,8.508-.722c-.041-.814-.094-1.609-.165-2.384a39.563,39.563,0,0,0-8.94.8,64.946,64.946,0,0,1-8.018,1.195Q122.377,343.606,122.312,344.809Z",
    transform: "translate(-122.312 -340.421)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(2.915 97.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M121.327,360.436a63.771,63.771,0,0,0,9.5-1.313,36.333,36.333,0,0,1,8.457-.73c.039-.79.071-1.584.1-2.374a39.5,39.5,0,0,0-9.15.8,62.224,62.224,0,0,1-8.705,1.242Q121.427,359.256,121.327,360.436Z",
    transform: "translate(-121.327 -356.001)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(1.875 108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M119.993,376.057a59.933,59.933,0,0,0,10.54-1.35,36.25,36.25,0,0,1,7.681-.746c.071-.769.139-1.562.207-2.371a39.515,39.515,0,0,0-8.485.814,59,59,0,0,1-9.7,1.287C120.158,374.5,120.076,375.291,119.993,376.057Z",
    transform: "translate(-119.993 -371.587)",
    fill: "#e3e3e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    transform: "translate(19.453 5.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567",
    transform: "translate(29.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M146.921,334.8c.4-.024.806-.05,1.211-.076,2.392-12.5,1.012-30.86.5-36.485-.532-5.84.49-13.35,2.8-20.6,1.795-5.63.694-18.683-.189-29.171-.248-2.944-.484-5.725-.623-8.01-.452-7.384,2.554-21.049,4.211-27.9l-1.09-.514c-1.66,6.78-4.775,20.756-4.3,28.471.142,2.295.378,5.081.626,8.03.878,10.407,1.97,23.355.234,28.8-2.351,7.366-3.387,15.01-2.844,20.971C147.966,303.955,149.354,322.425,146.921,334.8Z",
    transform: "translate(-146.921 -212.047)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    transform: "translate(0 0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M114.2,283.938c1.406,7.689.963,12.684.449,18.463-.165,1.87-.337,3.8-.458,5.933-.375,6.691-1.648,20.164-2.212,25.991.393.04.783.076,1.175.11.564-5.827,1.84-19.335,2.217-26.05.118-2.117.29-4.041.455-5.9.517-5.848.966-10.9-.464-18.715-.3-1.678-.629-3.379-.951-5.073-1.592-8.38-3.24-17.045-2.46-21.2.189-1.013.431-2.164.691-3.382,1.058-5.01,2.377-11.244,1.961-16.653-.413-5.362-2.885-19.882-3.833-25.354-.366.176-.732.355-1.1.533.989,5.723,3.355,19.684,3.756,24.892.405,5.275-.9,11.438-1.943,16.389-.26,1.223-.505,2.379-.7,3.4-.809,4.325.779,12.688,2.463,21.546C113.573,280.564,113.895,282.263,114.2,283.938Z",
    transform: "translate(-109.672 -212.111)",
    fill: "#ffdebb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(0 65.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M78.978,238.59s-12.032,35.678-15.012,48.392-3.21,39.147-3.21,39.147-5.259,9.709-5.384,14.03c-.132,4.606,2.587,8.271,2.277,11.286s3.817,1.378,2.652-4.728,2.142-11.636,3.569-11.458-1.181,6.666.087,9,2.909-2.2,4.54-4.96c1.694-2.862,1.6-9.107.825-13.564s8.316-31.533,8.36-39.378l11.507-34.576S85.385,237.35,78.978,238.59Z",
    transform: "translate(-55.367 -230.252)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M91.912,247.256a83.75,83.75,0,0,1-3.676,11.181v0c-.157.417-.316.843-.475,1.276a.366.366,0,0,0-.023.061c-.461,1.232-.942,2.521-1.439,3.855l-.009.024c-2.04,5.509-4.3,11.812-6.2,18.287-.652,2.216-1.261,4.456-1.8,6.688-.691,2.85-1.276,5.691-1.7,8.472-1.539,10.017-4.479,22.706-4.479,22.706-4.315,1.575-11.06-.5-11.06-.5s-.175-18.274.789-25.374a171.381,171.381,0,0,1,4.583-22.2c5.168-19.744,14.264-39.063,16.759-44.187.2-.41.355-.727.464-.947H85.79C90.016,228.98,93.014,241.08,91.912,247.256Z",
    transform: "translate(-56.618 -226.593)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M60.6,355.085l.338,4.205s6.413,1.853,11.22.548l1.271-3.751A39.991,39.991,0,0,1,60.6,355.085Z",
    transform: "translate(-56.522 -266.034)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(21.675 31.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M93.119,272.31v0a.5.5,0,0,1-.035.181c-.145.355-.293.72-.44,1.1a.368.368,0,0,0-.023.061c-.473,1.192-.954,2.489-1.439,3.855l-.009.024a188.871,188.871,0,0,0-6.243,21.74c.012-1.148.026-2.3.048-3.454-.652,2.216-1.261,4.456-1.8,6.688a72.555,72.555,0,0,1,1.833-8.781,188.632,188.632,0,0,1,6.964-21.588.614.614,0,0,1,.759-.313A.528.528,0,0,1,93.119,272.31Z",
    transform: "translate(-83.176 -271.789)",
    fill: "#ffdebb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(208.704 116.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577",
    transform: "translate(87.028 173.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M371.731,400.015h28.421c-.094-1.753-.187-3.433-.278-5.02-.5-8.653-.917-14.546-.917-14.546l-23.113.913-1.917.078-3.4.135s.328,5.269.839,12.988C371.479,396.269,371.6,398.1,371.731,400.015Z",
    transform: "translate(-370.527 -380.449)",
    fill: "#18315b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M373.927,381.439l-3.4.135s.328,5.269.839,12.988a232.1,232.1,0,0,0,28.508.432c-.5-8.653-.917-14.546-.917-14.546l-23.113.913Z",
    transform: "translate(-370.527 -380.449)",
    fill: "#000b29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(3.398 0.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M377.984,400.42c-.52-8.01-.945-14.853-1.18-18.652l-1.917.077c.233,3.782.657,10.593,1.175,18.575Z",
    transform: "translate(-374.887 -381.768)",
    fill: "#000b29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(51.472 173.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M353.33,400.015c.147-2.17.284-4.228.408-6.125.489-7.353.8-12.316.8-12.316l-3.689-.146-1.913-.077-22.831-.9s-.25,3.512-.594,9.094c-.182,2.975-.39,6.54-.6,10.473Z",
    transform: "translate(-324.908 -380.449)",
    fill: "#18315b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M325.678,389.542a279.665,279.665,0,0,0,28.23,4.348c.489-7.353.8-12.316.8-12.316l-3.689-.146-1.913-.077-22.831-.9S326.022,383.961,325.678,389.542Z",
    transform: "translate(-325.078 -380.449)",
    fill: "#000b29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(22.843 0.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M356.136,400.415c.518-7.99.942-14.807,1.174-18.587l-1.913-.076c-.234,3.8-.66,10.645-1.18,18.663Z",
    transform: "translate(-354.216 -381.752)",
    fill: "#000b29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(48.546 51.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M392.193,330.535a151.486,151.486,0,0,1-17.368,3.2q-3.021.377-6.037.625-4.07.335-8.137.449-6.727.183-13.456-.261a151.841,151.841,0,0,1-26.019-4.018c-.08-7.191.041-32.98.648-57.854.03-1.117.057-2.233.088-3.343,0-.236.012-.472.018-.708.005-.257.014-.514.022-.769.02-.789.043-1.576.065-2.358q.068-2.4.143-4.751.047-1.408.094-2.8c.005-.192.013-.383.02-.573q.033-.915.065-1.819v0c.008-.186.014-.374.022-.561.019-.555.041-1.107.061-1.654.019-.466.037-.925.055-1.387.672-16.779,1.654-30.015,3.06-31.88,2.385-3.164,10.508-7.363,17.042-10.781,2.327-1.216,5.107-2.48,6.7-3.419,2.32,1.661,4,3.162,7.443,3.059,3.848-.117,4.8-2.175,6.264-3.939.9.517,3.171,2.177,4.354,2.793,1.012.531,2.108,1.094,3.251,1.679,1.768.9,3.648,1.855,5.51,2.83,2.76,1.445,5.48,2.935,7.737,4.359a19.734,19.734,0,0,1,4.929,3.963c1.277,1.7,2.1,12.743,2.636,27.269.022.509.037,1.024.059,1.543,0,.062,0,.125,0,.19.022.528.04,1.069.054,1.611q.079,2.452.153,5c.01.358.02.719.026,1.079.008.271.018.543.019.811.018.7.035,1.4.053,2.106,0,.141.006.284.01.425.043,1.864.084,3.754.122,5.659q.018.836.031,1.675C392.417,294.147,392.3,322.808,392.193,330.535Z",
    transform: "translate(-321.155 -205.003)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M392.157,289.049l-9.167,8.269-8.542-7.7-8.539,7.7-8.573-7.731-8.577,7.731-8.63-7.782-8.632,7.782-9.319-8.4c.02-.789.043-1.576.065-2.358q.068-2.4.143-4.751l9.111-8.217,8.632,7.784,8.63-7.784,8.577,7.731,8.573-7.731,8.539,7.7,8.542-7.7L392,281.714c.043,1.864.084,3.754.122,5.659Q392.143,288.209,392.157,289.049Z",
    transform: "translate(-321.381 -226.055)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    transform: "translate(13.873 86.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M380.033,348.917h0c-12.276-.048-22.753-5.015-29.382-9.173a65.1,65.1,0,0,1-11.556-9.1.485.485,0,0,1,.073-.739.641.641,0,0,1,.832.063,63.885,63.885,0,0,0,11.36,8.935c6.484,4.064,16.723,8.918,28.678,8.965a.529.529,0,1,1,0,1.05Z",
    transform: "translate(-338.954 -329.78)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(26.97 88.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M376.083,343.563c-10.452-1.827-19.7-8.945-20.124-9.272a.486.486,0,0,1-.056-.741.644.644,0,0,1,.833-.05c.109.085,11,8.456,22.092,9.356a.543.543,0,0,1,.535.571.575.575,0,0,1-.642.475C377.836,343.831,376.955,343.716,376.083,343.563Z",
    transform: "translate(-355.757 -333.371)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    transform: "translate(25.773 5.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M354.811,225.982a.576.576,0,0,1-.579-.428.532.532,0,0,1,.47-.614c14.966-2.525,19.477-11.086,19.52-11.172a.623.623,0,0,1,.782-.263.5.5,0,0,1,.295.7c-.189.372-4.813,9.146-20.377,11.771A.663.663,0,0,1,354.811,225.982Z",
    transform: "translate(-354.221 -213.459)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(1.12 40.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M329.573,264.5v0a.481.481,0,0,1-.08.168c-.224.32-.458.65-.691.987a.542.542,0,0,0-.035.056c-.749,1.076-1.528,2.252-2.332,3.494a.04.04,0,0,1-.014.021c-1.255,1.954-2.556,4.073-3.828,6.226q.033-.915.065-1.819v0c.008-.186.014-.374.022-.561,2.053-3.388,4.1-6.559,5.817-8.963a.639.639,0,0,1,.817-.162A.5.5,0,0,1,329.573,264.5Z",
    transform: "translate(-322.592 -263.866)",
    fill: "#ffdebb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(101.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M425.813,213.349s19.138-5.47,24.8-16.637c1.638-3.234-11.856-36.071-11.856-36.071l-6.514.281s1.857,11.392,2.981,17.843c.926,5.3,2.421,11.642,2.924,13.729.11.453.171.7.171.7-.32.049-.64.1-.966.161-8.942,1.615-20.358,6.794-20.358,6.794Z",
    transform: "translate(-395.409 -139.96)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590",
    transform: "translate(41.947 52.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M448.891,210.454a.665.665,0,0,0,.857-.12.5.5,0,0,0-.135-.761,49.78,49.78,0,0,0-5.7-2.97c.11.453.171.7.171.7-.32.049-.64.1-.966.161A50.064,50.064,0,0,1,448.891,210.454Z",
    transform: "translate(-443.118 -206.603)",
    fill: "#f97853"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M390.42,213.1s-5.789,12.08,8.948,18.805c10.2,4.655,33.435-7.5,33.435-7.5l-8.284-15.639S403.261,216.566,390.42,213.1Z",
    transform: "translate(-389.299 -154.732)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M437.23,133.02c-.576.36-.458,2.578-.2,4.668l-.248.036c-.685-2.789-2.048-7.532-3.215-6.627-.764.593.259,4.683.956,7.129q-.216.059-.433.121c-.878-2.9-2.772-8.5-4.032-7.41-.841.726.773,5.651,1.669,8.164l-.367.128c-.857-2.437-2.689-7.048-3.944-5.965-1.136.981,2.119,7.951,2.119,7.951h0l.854,2.736s-1.015.389-2.6-1.2-3.477-1.873-2.162.431c1.486,2.6,3.686,4.471,4.654,6.313s4.015,2.452,4.015,2.452l6.116-.263s1.186-9.192-1.1-13.573h0C438.923,135.5,438.234,132.395,437.23,133.02Z",
    transform: "translate(-397.215 -130.799)",
    fill: "#ffa681"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(62.596 6.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M343.549,157.169c0,9.264,6.414,15.646,16.827,15.646s17.68-6.862,17.68-16.125a17.9,17.9,0,0,0-1.37-7.051c-.053-.125-.106-.252-.164-.374-.111-.24-.225-.479-.349-.711-.181-.358-.384-.708-.6-1.046-2.714-4.339-7.576-7.1-14.109-7.1C348.977,140.411,343.549,147.906,343.549,157.169Z",
    transform: "translate(-340.144 -140.411)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594",
    transform: "translate(0 19.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M344.924,169.585s-2.894-3.431-5.046-.594.89,11.218,6.159,9.172Z",
    transform: "translate(-339.181 -167.868)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(1.129 3.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M345.207,176.9a.441.441,0,0,1-.429-.29c-.816-2.587-3.831-3.636-3.861-3.646a.385.385,0,0,1-.258-.511.465.465,0,0,1,.574-.23c.141.048,3.463,1.194,4.4,4.174a.392.392,0,0,1-.308.488A.485.485,0,0,1,345.207,176.9Z",
    transform: "translate(-340.63 -172.202)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    transform: "translate(2.219 4.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M342.472,176.29a.483.483,0,0,1-.241-.063.371.371,0,0,1-.133-.548,3.967,3.967,0,0,1,1.672-1.2.469.469,0,0,1,.588.2.38.38,0,0,1-.224.523,3.149,3.149,0,0,0-1.286.9A.46.46,0,0,1,342.472,176.29Z",
    transform: "translate(-342.027 -174.447)",
    fill: "#ea5143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599",
    transform: "translate(34.456 19.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M384.5,169.585s2.894-3.431,5.046-.594-.89,11.218-6.159,9.172Z",
    transform: "translate(-383.389 -167.868)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595",
    transform: "translate(0.704 3.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M384.739,176.9a.442.442,0,0,0,.429-.29c.816-2.587,3.831-3.636,3.861-3.646a.386.386,0,0,0,.258-.511.465.465,0,0,0-.574-.23c-.141.048-3.463,1.194-4.4,4.174a.392.392,0,0,0,.309.488A.485.485,0,0,0,384.739,176.9Z",
    transform: "translate(-384.293 -172.202)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(2.269 4.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M388.224,176.29a.478.478,0,0,0,.24-.063.37.37,0,0,0,.133-.548,3.955,3.955,0,0,0-1.671-1.2.469.469,0,0,0-.588.2.38.38,0,0,0,.224.523,3.149,3.149,0,0,1,1.286.9A.46.46,0,0,0,388.224,176.29Z",
    transform: "translate(-386.3 -174.447)",
    fill: "#ea5143"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M370.945,192.979v8.334s-2.795,4.244-6.575,4.533-7.132-3.654-7.132-3.654v-8.627Z",
    transform: "translate(-343.164 -156.547)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M370.945,192.979v3.7c-2.536,2.5-7.041,3.128-13.707,2.252v-5.364Z",
    transform: "translate(-343.164 -156.547)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M377.98,157.461a72.477,72.477,0,0,1-1.216,10.527c-.173.807-.369,1.568-.588,2.249-1.972,6.14-6.906,16.671-20.718,12.285-6.1-1.936-8.927-7.978-10.187-14.122a52.95,52.95,0,0,1-.922-11.4,8.61,8.61,0,0,1,4.965-7.4c8.153-4.11,16.755-2.577,22.418-.641A8.706,8.706,0,0,1,377.98,157.461Z",
    transform: "translate(-340.318 -142.432)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M357.433,171.2c0,.889-.515,1.611-1.151,1.611s-1.152-.721-1.152-1.611.515-1.611,1.152-1.611S357.433,170.312,357.433,171.2Z",
    transform: "translate(-342.699 -149.368)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M374.85,171.154c0,.889-.516,1.611-1.152,1.611s-1.152-.721-1.152-1.611.516-1.611,1.152-1.611S374.85,170.264,374.85,171.154Z",
    transform: "translate(-346.541 -149.353)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M377.021,163.6s-3.634-1.277-6.432-.2l.28,1.383s4.107-.308,6.175.437A2.151,2.151,0,0,0,377.021,163.6Z",
    transform: "translate(-346.109 -147.335)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M351.629,163.6s3.634-1.277,6.432-.2l-.28,1.383s-4.107-.308-6.175.437A2.151,2.151,0,0,1,351.629,163.6Z",
    transform: "translate(-341.889 -147.335)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(19.155 20.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M365.413,178.226a5.266,5.266,0,0,0,1.612-.3.382.382,0,0,0,.243-.516.465.465,0,0,0-.58-.217,2.979,2.979,0,0,1-1.786.15.423.423,0,0,1-.218-.369,53.163,53.163,0,0,1,.269-6.063.413.413,0,0,0-.408-.427.432.432,0,0,0-.48.362,52.227,52.227,0,0,0-.267,6.21,1.206,1.206,0,0,0,.648.967A2.07,2.07,0,0,0,365.413,178.226Z",
    transform: "translate(-363.757 -170.48)",
    fill: "#f97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M358.211,184.557a5.884,5.884,0,0,0,11.482,0Z",
    transform: "translate(-343.379 -153.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(18.028 36.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M364.61,194.2a5.075,5.075,0,0,0,2.171-.541.371.371,0,0,0,.15-.543.478.478,0,0,0-.611-.134,4.123,4.123,0,0,1-1.709.427,3.932,3.932,0,0,1-1.62-.425.478.478,0,0,0-.613.129.371.371,0,0,0,.145.545A4.839,4.839,0,0,0,364.61,194.2Z",
    transform: "translate(-362.31 -192.927)",
    fill: "#f97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M377.51,163.248h-2.018c.223-1.8.542-4.974-1.122-5.429-5.258-1.436,1.556-4.74-.818-6.386s-8.28-.944-12.388-1.062c-4.133-.119-10.776-.067-12.388.265s-.73,2.715-.138,4.564-1.981,3.888-2.414,5.8a7.483,7.483,0,0,0,0,2.248h-1.683A59.651,59.651,0,0,1,344.35,157a8.61,8.61,0,0,1,4.965-7.4c8.153-4.11,16.755-2.577,22.418-.641a8.706,8.706,0,0,1,6.247,8.508C377.885,159.236,377.737,161.254,377.51,163.248Z",
    transform: "translate(-340.318 -142.432)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(3.116 17.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    transform: "translate(5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M354.92,174.675a4.513,4.513,0,1,1,5.041-4.482A4.791,4.791,0,0,1,354.92,174.675Zm0-8.265a3.809,3.809,0,1,0,4.255,3.783A4.045,4.045,0,0,0,354.92,166.41Z",
    transform: "translate(-349.88 -165.711)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(19.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M372.6,174.675a4.513,4.513,0,1,1,5.04-4.482A4.791,4.791,0,0,1,372.6,174.675Zm0-8.265a3.809,3.809,0,1,0,4.255,3.783A4.045,4.045,0,0,0,372.6,166.41Z",
    transform: "translate(-367.557 -165.711)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(0 0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M349.254,169.078a.416.416,0,0,1-.277-.1h0a6.664,6.664,0,0,0-5.316-1.372.4.4,0,0,1-.472-.261.351.351,0,0,1,.293-.42,7.4,7.4,0,0,1,6.049,1.557.323.323,0,0,1,0,.494A.417.417,0,0,1,349.254,169.078Z",
    transform: "translate(-343.179 -166.781)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(27.93 0.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M379.406,169.035a.407.407,0,0,1-.329-.158.327.327,0,0,1,.114-.484c.15-.087,3.717-2.133,6.752-1.688a.355.355,0,0,1,.323.4.389.389,0,0,1-.451.288c-2.732-.4-6.16,1.565-6.195,1.584A.422.422,0,0,1,379.406,169.035Z",
    transform: "translate(-379.013 -166.642)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(14.383 1.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M366.527,169.914a3.231,3.231,0,0,0-2.169-1.134,2.929,2.929,0,0,0-2.068,1.132l-.658-.382a3.69,3.69,0,0,1,2.726-1.448,4,4,0,0,1,2.807,1.424Z",
    transform: "translate(-361.632 -168.082)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(0 66.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M313.857,252.451a125.682,125.682,0,0,1-11.563,16.384,44.891,44.891,0,0,1-5.668,5.628c-3.074,2.468-6.072,3.759-8.514,2.663-9.056-4.059-29.244-36.366-29.244-36.366l4.972-5.244s8.985,9.227,15.556,14.748c6.06,5.092,10.72,8.9,10.72,8.9.839-1.135,1.733-2.379,2.662-3.7.988-1.4,2.013-2.877,3.057-4.4,7.567-11.047,15.962-24.307,15.962-24.307Z",
    transform: "translate(-258.869 -226.762)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M311.892,279.6a44.9,44.9,0,0,1-5.668,5.628l-3.848-19c.988-1.4,2.013-2.877,3.057-4.4Z",
    transform: "translate(-268.466 -237.528)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M321.642,226.762l-18.148,25.38,6.091,22.322L324.6,252.72S326.424,237.845,321.642,226.762Z",
    transform: "translate(-268.713 -226.762)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(161.826 119.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    transform: "translate(2.391 46.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M276.389,385.168c-1.3-6.387-2.574-13.591-3.735-20.586q-.382-2.32-.75-4.594c-.931-5.792-1.763-11.269-2.431-15.813-.254-1.726-.483-3.32-.691-4.743-.648-4.536-1.028-7.354-1.028-7.354l-28.658.963-28.746-.963s-.74,5.576-1.927,13.659c-.217,1.471-.448,3.023-.691,4.643-.638,4.242-1.368,8.927-2.153,13.724l-.035.211c-.246,1.495-.495,3-.753,4.505a.4.4,0,0,1-.012.06v0c-.615,3.638-1.26,7.271-1.915,10.766-.27,1.443-.542,2.86-.818,4.24q-.127.645-.256,1.278Z",
    transform: "translate(-201.791 -242.187)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(0.256 95.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M219.718,342.057a2.719,2.719,0,1,1-2.7-2.4A2.564,2.564,0,0,1,219.718,342.057Z",
    transform: "translate(-204.81 -339.656)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M228.318,355.483a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,228.318,355.483Z",
    transform: "translate(-206.707 -343.777)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M245.237,348.552a2.719,2.719,0,1,1-2.7-2.4A2.564,2.564,0,0,1,245.237,348.552Z",
    transform: "translate(-210.439 -341.649)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M218.534,369.741a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,218.534,369.741Z",
    transform: "translate(-204.548 -348.154)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M239.676,368.259a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,239.676,368.259Z",
    transform: "translate(-209.212 -347.699)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M211.861,354.039a2.528,2.528,0,0,1-2.448,2.391c.243-1.62.475-3.172.691-4.643A2.43,2.43,0,0,1,211.861,354.039Z",
    transform: "translate(-203.728 -343.38)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M274.129,388.619a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,274.129,388.619Z",
    transform: "translate(-216.812 -353.948)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M272.492,369.741a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,272.492,369.741Z",
    transform: "translate(-216.451 -348.154)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M291.645,376.935a3.007,3.007,0,0,1-1.06.191,2.418,2.418,0,1,1,0-4.8,2.415,2.415,0,0,1,.31.018Q291.264,374.61,291.645,376.935Z",
    transform: "translate(-221.038 -349.683)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M275.957,402.454a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,275.957,402.454Z",
    transform: "translate(-217.215 -358.195)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M290.78,396.922a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,290.78,396.922Z",
    transform: "translate(-220.485 -356.496)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M260.205,408.217a2.89,2.89,0,0,0-4.452,0Z",
    transform: "translate(-213.95 -360.379)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M216.253,391.633a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,216.253,391.633Z",
    transform: "translate(-204.045 -354.873)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M207.974,380.782a2.513,2.513,0,0,1-2.349,2.377.406.406,0,0,0,.012-.06c.258-1.505.507-3.011.753-4.506A2.412,2.412,0,0,1,207.974,380.782Z",
    transform: "translate(-202.892 -351.608)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M204.043,402.657a2.463,2.463,0,0,1-1.924,2.3c.275-1.381.548-2.8.818-4.24A2.33,2.33,0,0,1,204.043,402.657Z",
    transform: "translate(-202.119 -358.399)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M224.853,403.918a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,224.853,403.918Z",
    transform: "translate(-205.942 -358.644)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M243.141,401.2a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,243.141,401.2Z",
    transform: "translate(-209.976 -357.811)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M230.094,384.165a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,230.094,384.165Z",
    transform: "translate(-207.098 -352.581)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M248.7,380.7a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,248.7,380.7Z",
    transform: "translate(-211.203 -351.517)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M257.08,362.414a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,257.08,362.414Z",
    transform: "translate(-213.051 -345.904)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M287.7,347.432a2.85,2.85,0,0,1-.58.057,2.412,2.412,0,1,1-.111-4.8C287.217,344.111,287.446,345.705,287.7,347.432Z",
    transform: "translate(-220.273 -340.587)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M269.026,348.552a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,269.026,348.552Z",
    transform: "translate(-215.686 -341.649)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M281.719,360.9a2.72,2.72,0,1,1-2.7-2.4A2.565,2.565,0,0,1,281.719,360.9Z",
    transform: "translate(-218.486 -345.44)",
    fill: "#ffdebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M260.545,391.633a2.72,2.72,0,1,1-2.7-2.4A2.564,2.564,0,0,1,260.545,391.633Z",
    transform: "translate(-213.815 -354.873)",
    fill: "#ffdebb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M271.289,292.9c-15.118,8.776-42.877,8.089-60.321,0,1.666-9.229,3.86-18.469,3.389-30.753q-.079-2.02-.193-4.011-.1-1.731-.226-3.433c-1.505-20.435-5.427-37.144-3.5-39.3a17.879,17.879,0,0,1,3.974-3.01c.68-.412,1.406-.828,2.173-1.245,1.81-.981,3.822-1.971,5.843-2.935,4.794-2.276,9.662-4.388,12.1-5.831a17.086,17.086,0,0,0,6.423,1.44c.055,0,.117,0,.178-.006s.118.006.173.006a17.107,17.107,0,0,0,6.426-1.44c2.264,1.338,6.525,3.206,10.875,5.242a97.624,97.624,0,0,1,8.962,4.628,17.542,17.542,0,0,1,3.828,2.925c.955,1.07.553,5.763-.263,12.716-.808,6.842-2.018,15.876-2.75,25.806-.2,2.758-.369,5.583-.481,8.451C267.432,274.426,269.623,283.666,271.289,292.9Z",
    transform: "translate(-203.583 -202.374)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(17.721 61.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M265.267,309.855h0c-12.174-.048-22.566-4.973-29.139-9.1a64.491,64.491,0,0,1-11.46-9.025.482.482,0,0,1,.071-.733.638.638,0,0,1,.825.063,63.406,63.406,0,0,0,11.266,8.861c6.43,4.03,16.584,8.844,28.442,8.891a.524.524,0,1,1,0,1.042Z",
    transform: "translate(-224.528 -290.877)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(30.242 63.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M260.751,304.69c-10.366-1.812-19.541-8.871-19.958-9.2a.482.482,0,0,1-.055-.735.64.64,0,0,1,.827-.049c.108.083,10.906,8.386,21.909,9.279a.539.539,0,0,1,.531.566.571.571,0,0,1-.637.471C262.489,304.956,261.615,304.841,260.751,304.69Z",
    transform: "translate(-240.592 -294.583)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(34.469 13.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M246.6,234.86a.572.572,0,0,1-.575-.424.528.528,0,0,1,.466-.608c14.843-2.5,19.316-11,19.36-11.081a.618.618,0,0,1,.776-.26.5.5,0,0,1,.292.689c-.188.369-4.774,9.071-20.209,11.674A.671.671,0,0,1,246.6,234.86Z",
    transform: "translate(-246.015 -222.44)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M262.145,207.617c-2.946,5.975-10.188,12.162-19.607,10.716-9.121-1.4-13.446-5.691-16.568-10.128,4.795-2.277,9.662-4.386,12.1-5.83a17.154,17.154,0,0,0,6.422,1.441,1.755,1.755,0,0,0,.179-.006,1.644,1.644,0,0,0,.175.006,17.182,17.182,0,0,0,6.425-1.441C253.536,203.713,257.8,205.58,262.145,207.617Z",
    transform: "translate(-207.125 -202.374)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(26.243 0.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M256.365,203.006a.44.44,0,0,0-.468.412c0,.335-.157,8.234-8.131,8.846-7.4.572-10.457-5.724-11.4-8.335a.412.412,0,0,0-.4-.256h-.087a.379.379,0,0,0-.4.487c1.009,2.695,4.233,9.2,11.768,8.963q.293-.009.595-.032c8.825-.677,8.982-9.577,8.983-9.667A.441.441,0,0,0,256.365,203.006Z",
    transform: "translate(-235.461 -203.006)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(16.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M258.785,142.43s7.126,9.815,6.345,20.038,1.051,22.025-9.238,21.507-28.638,3.668-34.47-4.295S258.785,142.43,258.785,142.43Z",
    transform: "translate(-219.922 -137.161)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M267.329,168.4s1.85,14.819-6.058,18.9-13.63-.475-13.63-.475S264.309,166.164,267.329,168.4Z",
    transform: "translate(-225.824 -145.079)",
    fill: "#000b29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(3.022 7.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(0 14.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M229.162,167.625s-2.839-3.367-4.951-.583.874,11.006,6.043,9Z",
    transform: "translate(-223.527 -165.939)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(1.108 2.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M229.439,174.8a.434.434,0,0,1-.421-.283c-.8-2.539-3.758-3.568-3.788-3.578a.377.377,0,0,1-.253-.5.455.455,0,0,1,.563-.226c.138.046,3.4,1.171,4.32,4.095a.386.386,0,0,1-.3.479A.488.488,0,0,1,229.439,174.8Z",
    transform: "translate(-224.948 -170.192)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(2.177 4.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M226.756,174.2a.474.474,0,0,1-.235-.062.363.363,0,0,1-.131-.537,3.9,3.9,0,0,1,1.639-1.175.46.46,0,0,1,.578.2.373.373,0,0,1-.221.514,3.1,3.1,0,0,0-1.262.886A.451.451,0,0,1,226.756,174.2Z",
    transform: "translate(-226.319 -172.394)",
    fill: "#ea5143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    transform: "translate(33.806 14.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M267.993,167.625s2.839-3.367,4.951-.583-.874,11.006-6.044,9Z",
    transform: "translate(-266.9 -165.939)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    transform: "translate(0.692 2.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M268.224,174.8a.433.433,0,0,0,.421-.283c.8-2.539,3.758-3.568,3.789-3.578a.378.378,0,0,0,.253-.5.454.454,0,0,0-.562-.226c-.139.046-3.4,1.171-4.32,4.095a.385.385,0,0,0,.3.479A.5.5,0,0,0,268.224,174.8Z",
    transform: "translate(-267.788 -170.192)",
    fill: "#ea5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(2.227 4.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M271.645,174.2a.479.479,0,0,0,.236-.062.364.364,0,0,0,.131-.537,3.9,3.9,0,0,0-1.64-1.175.459.459,0,0,0-.577.2.373.373,0,0,0,.22.514,3.094,3.094,0,0,1,1.262.886A.452.452,0,0,0,271.645,174.2Z",
    transform: "translate(-269.757 -172.394)",
    fill: "#ea5143"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M254.691,190.577v8.177s-2.742,4.164-6.45,4.448-7-3.586-7-3.586v-8.464Z",
    transform: "translate(-227.435 -159.309)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M254.691,190.577v3.628c-2.489,2.455-6.906,3.325-13.446,2.467l0-5.52Z",
    transform: "translate(-227.435 -159.309)",
    fill: "#f97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M261.594,155.729a71.161,71.161,0,0,1-1.192,10.329c-.171.792-.362,1.538-.577,2.206-1.935,6.025-6.775,16.357-20.326,12.054-5.985-1.9-8.759-7.827-10-13.856a51.929,51.929,0,0,1-.9-11.187,8.446,8.446,0,0,1,4.871-7.264c8-4.032,16.439-2.529,22-.629A8.542,8.542,0,0,1,261.594,155.729Z",
    transform: "translate(-224.643 -145.46)",
    fill: "#ffa681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M241.233,168.363c0,.873-.507,1.58-1.13,1.58s-1.13-.708-1.13-1.58.506-1.58,1.13-1.58S241.233,167.491,241.233,168.363Z",
    transform: "translate(-226.934 -152.005)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M259.136,168.363c0,.873-.506,1.58-1.129,1.58s-1.13-.708-1.13-1.58.506-1.58,1.13-1.58S259.136,167.491,259.136,168.363Z",
    transform: "translate(-230.883 -152.005)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M237.036,161.989a21.036,21.036,0,0,1,4.834-.644.78.78,0,0,1,.836.875l0,.011a.821.821,0,0,1-.864.611,23.75,23.75,0,0,0-6.619.721,1.066,1.066,0,0,1,.385-.8A2.99,2.99,0,0,1,237.036,161.989Z",
    transform: "translate(-226.105 -150.336)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M259.367,162.036a21.035,21.035,0,0,0-4.834-.644.779.779,0,0,0-.836.875l0,.012a.822.822,0,0,0,.864.611,23.726,23.726,0,0,1,6.619.721,1.066,1.066,0,0,0-.385-.8A2.988,2.988,0,0,0,259.367,162.036Z",
    transform: "translate(-230.179 -150.351)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(18.794 15.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M249.264,176.1a2.039,2.039,0,0,1-.95-.2,1.184,1.184,0,0,1-.635-.949,51.141,51.141,0,0,1,.263-6.093.424.424,0,0,1,.471-.356.406.406,0,0,1,.4.419,52.306,52.306,0,0,0-.264,5.949.417.417,0,0,0,.215.362,2.921,2.921,0,0,0,1.752-.148.457.457,0,0,1,.569.213.375.375,0,0,1-.238.506A5.163,5.163,0,0,1,249.264,176.1Z",
    transform: "translate(-247.639 -168.502)",
    fill: "#f97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M242.606,183.006a4.959,4.959,0,0,0,5.126,4.2,4.777,4.777,0,0,0,5.1-4.2Z",
    transform: "translate(-227.735 -156.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(17.687 31.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M248.476,191.777a4.74,4.74,0,0,1-2.049-.533.364.364,0,0,1-.142-.534.47.47,0,0,1,.6-.127h0a3.825,3.825,0,0,0,1.591.417,4.055,4.055,0,0,0,1.677-.419.469.469,0,0,1,.6.132.365.365,0,0,1-.147.532A4.983,4.983,0,0,1,248.476,191.777Z",
    transform: "translate(-246.22 -190.525)",
    fill: "#f97853"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M263.045,151.833a1.425,1.425,0,0,1-1.052.716,22.073,22.073,0,0,1-.157,2.875c-.539,5.614-2.132,6.6-2.493,5.212a57.649,57.649,0,0,1-.108-7.933,23.022,23.022,0,0,1-2.314-.258l-1.464-5.451-.512,5.383c-2.2.68-7.323-.409-7.323-.409L245.9,146.6l-1.063,5.169c-3.3,1.427-7.413.477-7.413.477l-.946-5.576-2.185,5.576s-7.029,2.242-7.105,0c-.047-1.305,1.028-4.98,1.936-7.826a12.12,12.12,0,0,1,6.385-7.206c8.719-4.161,17.938-1.948,21.1-.268C263.32,140.5,263.045,151.833,263.045,151.833Z",
    transform: "translate(-221.313 -134.827)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M229.4,143.029s-5.787,6.12-7.69,17.05-4.539,19.006,2.867,22.615c8.016,3.906,7.323-4.1,7.207-6.283s-6.935-8.129-2.384-24.891C230.868,146.109,229.4,143.029,229.4,143.029Z",
    transform: "translate(-219.65 -137.345)",
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M230.423,175.619v.013c0,.081.009.516.044,1.2.018.422.047.935.09,1.518.273,3.682,1.078,10.042,3.444,12.248.935.873,2.736,1.31,4.857,1.487v-2.894a12.42,12.42,0,0,1-5.327-4.4,25.065,25.065,0,0,1-2.947-8.078Z",
    transform: "translate(-222.026 -147.348)",
    fill: "#000b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M270.491,180.377a1.031,1.031,0,1,1-1.023-.91A.972.972,0,0,1,270.491,180.377Z",
    transform: "translate(-230.413 -148.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(0 59.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M282.494,261.632c-2.9,7.38-15.881,6.843-30.668,2.808l-.065-.017c-.047-.012-.091-.026-.138-.038l-2.034-.577c-.281-.082-.563-.165-.843-.25q-2.391-.711-4.811-1.531c-5.284-1.785-10.608-3.9-15.628-6.155l.035-.078,1.511-3.492.517-1.189s27.413,2.656,41.2.094c.234-.043.461-.087.686-.133a6.879,6.879,0,0,0-.158-.809c-7.3-22.108.684-26.348,3.357-29.431C275.451,220.834,287.967,247.7,282.494,261.632Z",
    transform: "translate(-205.249 -220.834)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(66.317 29.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M290.271,267.825a.66.66,0,0,1-.256.052.6.6,0,0,1-.526-.291c-1.044-1.9-4.59-3.033-5.679-3.344.234-.043.461-.087.686-.133-.055-.272-.108-.542-.158-.809,1.386.407,5,1.647,6.2,3.83A.5.5,0,0,1,290.271,267.825Z",
    transform: "translate(-283.81 -263.3)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    transform: "translate(23.307 30.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M239.7,267.161c-5.595,0-10.138-.286-10.534-.311a.544.544,0,0,1-.54-.557.568.568,0,0,1,.625-.48c.207.013,20.77,1.306,28.877-1.618a.613.613,0,0,1,.762.287.5.5,0,0,1-.322.676C254.083,266.777,246.186,267.161,239.7,267.161Z",
    transform: "translate(-228.627 -264.157)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    transform: "translate(44.339 33.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M255.612,278.437h0c4.691-1.15,8.955-2.271,11.418-2.973a13.247,13.247,0,0,0,7.534-6.661.612.612,0,0,1,.769-.267.5.5,0,0,1,.3.685,14.433,14.433,0,0,1-8.249,7.234c-1.787.509-4.517,1.237-7.671,2.038a7.947,7.947,0,0,1-4.106-.055Z",
    transform: "translate(-255.612 -268.492)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(1.095 0.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M256.019,260.335c-42.366,12.688-55.4,4.384-55.4,4.384-2.853-22.934,7.659-43.558,7.659-43.558a99.449,99.449,0,0,1,6.616,12.5l.927,17.58-.07.489-.033.23-.175,1.2,0,.024.273.052c12.815,2.4,36.252-.282,36.252-.282Z",
    transform: "translate(-200.129 -221.162)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(8.236 30.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M218.143,266.878a39.5,39.5,0,0,0-6.4,5.926.634.634,0,0,1-.82.1.484.484,0,0,1-.113-.728l0,0a40.682,40.682,0,0,1,7.234-6.574l-.175,1.2,0,.024Z",
    transform: "translate(-210.696 -265.599)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M266.763,263.191s4.691-9.474,11.821-8.631l2.15,6.849c-3.9,1.474-4.475,7.426-10.016,9.16Z",
    transform: "translate(-214.828 -231.397)",
    fill: "#ffa681"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M223.845,260.759a16.359,16.359,0,0,0-10.757-7.977c-7.795-1.795-12.761,1.472-13.285,2.7s2.94.055,2.94.055a6.764,6.764,0,0,0-3.549,2.453c-1.294,1.884,3.15-.149,3.15-.149s-3.186,1.242-3.592,2.392,3.8-.794,4.588-.756c0,0-3.753,1.326-3.727,2.514s4.31-.749,7.51-.6a56.2,56.2,0,0,1,8.107,1.332,60.122,60.122,0,0,0,7.386.864Z",
    transform: "translate(-198.724 -230.479)",
    fill: "#ffa681"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679",
    transform: "translate(37.395 85.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    transform: "translate(0 6.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    transform: "translate(219.596 4.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(0 7.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M326.054,121.71a4.685,4.685,0,1,1,5.233-4.652C331.287,119.622,328.939,121.71,326.054,121.71Zm0-7.846a3.215,3.215,0,1,0,3.592,3.194A3.413,3.413,0,0,0,326.054,113.864Z",
    transform: "translate(-320.821 -112.404)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    transform: "translate(45.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M384.629,110.3a4.685,4.685,0,1,1,5.233-4.653A4.974,4.974,0,0,1,384.629,110.3Zm0-7.846a3.215,3.215,0,1,0,3.592,3.193A3.413,3.413,0,0,0,384.629,102.457Z",
    transform: "translate(-379.396 -100.997)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(51.451 19.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638",
    transform: "translate(5.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M394.173,134.17a.78.78,0,0,1-.821-.73v-3.219a.826.826,0,0,1,1.641,0v3.219A.779.779,0,0,1,394.173,134.17Z",
    transform: "translate(-393.352 -129.491)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(0 5.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M394.173,142.3a.779.779,0,0,1-.821-.73v-3.219a.826.826,0,0,1,1.641,0v3.219A.779.779,0,0,1,394.173,142.3Z",
    transform: "translate(-393.352 -137.619)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(0 4.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639",
    transform: "translate(6.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M399.771,137.337H396.52a.735.735,0,1,1,0-1.46h3.252a.735.735,0,1,1,0,1.46Z",
    transform: "translate(-395.699 -135.877)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M390.905,137.337h-3.252a.735.735,0,1,1,0-1.46h3.252a.735.735,0,1,1,0,1.46Z",
    transform: "translate(-386.833 -135.877)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    transform: "translate(23.811 0.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(5.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M358.711,106.035a.78.78,0,0,1-.821-.73v-3.219a.826.826,0,0,1,1.641,0v3.219A.779.779,0,0,1,358.711,106.035Z",
    transform: "translate(-357.89 -101.356)",
    fill: "#f2cccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644",
    transform: "translate(0 5.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M358.711,114.162a.779.779,0,0,1-.821-.73v-3.219a.826.826,0,0,1,1.641,0v3.219A.779.779,0,0,1,358.711,114.162Z",
    transform: "translate(-357.89 -109.484)",
    fill: "#f2cccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(0 4.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(6.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M364.309,109.2h-3.252a.735.735,0,1,1,0-1.46h3.252a.735.735,0,1,1,0,1.46Z",
    transform: "translate(-360.237 -107.742)",
    fill: "#f2cccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M355.443,109.2h-3.252a.735.735,0,1,1,0-1.46h3.252a.735.735,0,1,1,0,1.46Z",
    transform: "translate(-351.371 -107.742)",
    fill: "#f2cccc"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653",
    transform: "translate(37.795 0.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M87.568,100.021a5.269,5.269,0,1,1,5.233,4.652A4.974,4.974,0,0,1,87.568,100.021Zm1.642,0A3.616,3.616,0,1,0,92.8,96.828,3.414,3.414,0,0,0,89.21,100.021Z",
    transform: "translate(-87.568 -95.368)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(16.782 18.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M60.607,125.611a5.269,5.269,0,1,1,5.232,4.653A4.974,4.974,0,0,1,60.607,125.611Zm1.641,0a3.616,3.616,0,1,0,3.591-3.194A3.414,3.414,0,0,0,62.248,125.611Z",
    transform: "translate(-60.607 -120.958)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(0 24.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(5.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M46.416,135.021a.779.779,0,0,0,.821-.73v-3.219a.826.826,0,0,0-1.641,0v3.219A.779.779,0,0,0,46.416,135.021Z",
    transform: "translate(-45.595 -130.343)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656",
    transform: "translate(0 5.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M46.416,143.149a.779.779,0,0,0,.821-.73V139.2a.826.826,0,0,0-1.641,0v3.219A.78.78,0,0,0,46.416,143.149Z",
    transform: "translate(-45.595 -138.47)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(0 4.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M39.9,138.189h3.252a.735.735,0,1,0,0-1.46H39.9a.735.735,0,1,0,0,1.46Z",
    transform: "translate(-39.076 -136.729)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(6.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M48.763,138.189h3.252a.735.735,0,1,0,0-1.46H48.763a.735.735,0,1,0,0,1.46Z",
    transform: "translate(-47.942 -136.729)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(18.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(5.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M70.683,99.321a.779.779,0,0,0,.821-.73V95.372a.826.826,0,0,0-1.641,0v3.219A.779.779,0,0,0,70.683,99.321Z",
    transform: "translate(-69.862 -94.642)",
    fill: "#f2cccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(0 5.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M70.683,107.448a.779.779,0,0,0,.821-.73V103.5a.826.826,0,0,0-1.641,0v3.219A.779.779,0,0,0,70.683,107.448Z",
    transform: "translate(-69.862 -102.77)",
    fill: "#f2cccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    transform: "translate(0 4.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M64.164,102.488h3.252a.735.735,0,1,0,0-1.46H64.164a.735.735,0,1,0,0,1.46Z",
    transform: "translate(-63.343 -101.028)",
    fill: "#f2cccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(6.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M73.03,102.488h3.252a.735.735,0,1,0,0-1.46H73.03a.735.735,0,1,0,0,1.46Z",
    transform: "translate(-72.209 -101.028)",
    fill: "#f2cccc"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(152.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(26.442 10.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M271.047,101.856a.645.645,0,0,1-.288-.038c-1-.374-1.58-.548-1.586-.55a.508.508,0,0,1-.368-.656.6.6,0,0,1,.737-.328c.025.008.627.187,1.67.578a.5.5,0,0,1,.31.679A.581.581,0,0,1,271.047,101.856Z",
    transform: "translate(-268.776 -100.259)",
    fill: "#efd2bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    transform: "translate(4.762 1.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M309.789,142.362c.4.94.768,1.91,1.1,2.882a.587.587,0,0,0,.618.363.574.574,0,0,0,.111-.02.511.511,0,0,0,.386-.647c-.343-.992-.722-1.982-1.126-2.941a.606.606,0,0,0-.751-.3A.5.5,0,0,0,309.789,142.362Z",
    transform: "translate(-282.577 -114.835)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M312.375,150.784c.267.974.509,1.976.718,2.979a.576.576,0,0,0,.634.421l.045-.006a.525.525,0,0,0,.467-.6c-.213-1.023-.459-2.044-.731-3.036a.591.591,0,0,0-.7-.381A.518.518,0,0,0,312.375,150.784Z",
    transform: "translate(-283.152 -117.439)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M315.344,171.829a.546.546,0,0,0,.521-.507c.018-1.04.01-2.083-.025-3.1a.558.558,0,0,0-.6-.5.548.548,0,0,0-.565.534c.034,1,.043,2.03.025,3.054a.551.551,0,0,0,.574.526A.6.6,0,0,0,315.344,171.829Z",
    transform: "translate(-283.663 -122.833)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M314.484,158.871a.534.534,0,0,0-.5.581c.069.468.131.942.186,1.407.064.537.121,1.085.168,1.628a.566.566,0,0,0,.627.476h.016a.539.539,0,0,0,.52-.556c-.049-.552-.107-1.11-.171-1.656-.055-.473-.119-.955-.189-1.432a.571.571,0,0,0-.638-.448Z",
    transform: "translate(-283.509 -120.116)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M307.689,137.061a.6.6,0,0,0,.593.3.643.643,0,0,0,.177-.042.5.5,0,0,0,.294-.685c-.475-.944-.989-1.885-1.528-2.8a.62.62,0,0,0-.787-.218.491.491,0,0,0-.244.7C306.721,135.216,307.223,136.137,307.689,137.061Z",
    transform: "translate(-281.777 -112.35)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M275.2,103.934c1,.455,2.011.949,3,1.471a.637.637,0,0,0,.358.069.59.59,0,0,0,.44-.252.487.487,0,0,0-.2-.71c-1.012-.533-2.044-1.038-3.065-1.5a.62.62,0,0,0-.784.225A.493.493,0,0,0,275.2,103.934Z",
    transform: "translate(-274.886 -102.954)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M285.576,110.2a.638.638,0,0,0,.415.1.6.6,0,0,0,.4-.2.481.481,0,0,0-.109-.726c-.924-.627-1.879-1.236-2.841-1.814a.628.628,0,0,0-.809.14.484.484,0,0,0,.157.719C283.734,108.989,284.671,109.587,285.576,110.2Z",
    transform: "translate(-276.573 -104.342)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M298.33,122.242a.634.634,0,0,0,.819.08.481.481,0,0,0,.09-.728c-.724-.8-1.488-1.6-2.27-2.365a.634.634,0,0,0-.823-.035.48.48,0,0,0-.04.733C296.872,120.675,297.621,121.455,298.33,122.242Z",
    transform: "translate(-279.533 -107.897)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M292.322,115.835a.625.625,0,0,0,.468.143.6.6,0,0,0,.356-.154.478.478,0,0,0-.011-.733c-.829-.717-1.7-1.424-2.58-2.1a.633.633,0,0,0-.822.055.479.479,0,0,0,.061.73C290.66,114.44,291.51,115.132,292.322,115.835Z",
    transform: "translate(-278.13 -105.996)",
    fill: "#efd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M303.484,129.351a.608.608,0,0,0,.559.245.636.636,0,0,0,.242-.073.487.487,0,0,0,.193-.712c-.6-.882-1.249-1.756-1.916-2.6a.631.631,0,0,0-.812-.127.483.483,0,0,0-.143.722C302.261,127.632,302.892,128.489,303.484,129.351Z",
    transform: "translate(-280.757 -110.024)",
    fill: "#efd2bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M263.552,93.728l2.551-8.4-31.253.239Z",
    transform: "translate(-234.85 -85.328)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M234.85,85.671l27.185,10.19.072.028,1.17,1.723.276-3.778Z",
    transform: "translate(-234.85 -85.433)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M270.6,102.136l-2.534-.355,1.364-1.368Z",
    transform: "translate(-242.178 -89.958)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M258.687,94.606l3.421,1.282-7.046,7.059L234.85,85.672Z",
    transform: "translate(-234.85 -85.433)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    transform: "translate(41.888 309.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    d: "M5.543,0H314.964a5.542,5.542,0,0,1,5.542,5.542v0a5.542,5.542,0,0,1-5.542,5.542H5.542A5.542,5.542,0,0,1,0,5.543v0A5.543,5.543,0,0,1,5.543,0Z",
    transform: "translate(0)",
    fill: "#ffd488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M365.347,413.97v.254H44.841v-.254c0-2.921,2.662-5.289,5.948-5.289H359.4C362.683,408.681,365.347,411.049,365.347,413.97Z",
    transform: "translate(-44.841 -408.681)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(148.228 240.228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 105.335,
    height: 52.56,
    rx: 5.381,
    fill: "#18315b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 16.314,
    height: 16.537,
    transform: "translate(44.511 52.5)",
    fill: "#000b29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 8.096,
    cy: 7.199,
    rx: 8.096,
    ry: 7.199,
    transform: "translate(44.389 19.725)",
    fill: "#1d567e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    d: "M5.866,0H36.212a5.866,5.866,0,0,1,5.866,5.866v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A5.866,5.866,0,0,1,5.866,0Z",
    transform: "translate(31.368 63.17)",
    fill: "#18315b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.94c7dc3a374e3e97dd6320253bdbcd84.svg";
export { ForwardRef as ReactComponent };